import React from 'react';

const Departments = () => {
  return (
    <div className="departments-page">
      <div className="page-header">
        <div className="container">
          <h1>Departments</h1>
          <p>Medical specializations and services</p>
        </div>
      </div>
      <div className="container section">
        <p>Departments listing page - To be implemented</p>
      </div>
    </div>
  );
};

export default Departments;
